module.exports = __webpack_public_path__ + "static/cta-bg-70b3b6e637318c01c55f312aaa98624a.webp";